import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var autoNotificationTypes = {
  PAYMENT_DUE_SOON: {
    id: 1,
    name: "Payment due soon"
  },
  PAYMENT_DUE_LATE_FIRST_WARNING: {
    id: 2,
    name: "Payment overdue first warning"
  }
};
export default {
  name: "OrderCommunications",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    order: Object
  },
  data: function data() {
    return {
      gettingAutoNotificationsHistoric: {
        cancellationToken: null,
        isPending: false,
        items: []
      },
      gettingAutoNotificationsConfigs: {
        cancellationToken: null,
        isPending: false,
        items: []
      },
      definingAutoNotificationConfig: {
        cancellationToken: null,
        isPending: false
      },
      deletingAutoNotificationConfig: {
        cancellationToken: null,
        isPending: false
      },
      autoNotificationTypes: autoNotificationTypes,
      autoNotificationTypes_paymentIds: Object.values(autoNotificationTypes).filter(function (x) {
        return [autoNotificationTypes.PAYMENT_DUE_SOON.id, autoNotificationTypes.PAYMENT_DUE_LATE_FIRST_WARNING.id].includes(x.id);
      }).map(function (x) {
        return x.id;
      }),
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.gettingAutoNotificationsConfigs.isPending || this.definingAutoNotificationConfig.isPending || this.deletingAutoNotificationConfig.isPending;
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.getAutoNotificationsHistoric();
            _this2.getAutoNotificationsConfigs();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getAutoNotificationsHistoric: function getAutoNotificationsHistoric() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$gettingAutoNot;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.gettingAutoNotificationsHistoric.isPending = true;
              _this3.gettingAutoNotificationsHistoric.items = [];
              (_this3$gettingAutoNot = _this3.gettingAutoNotificationsHistoric.cancellationToken) === null || _this3$gettingAutoNot === void 0 || _this3$gettingAutoNot.cancel();
              _this3.gettingAutoNotificationsHistoric.cancellationToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 7;
              return request("/v1/order-auto-notifications/".concat(_this3.order.id_order, "/sents"), "get", null, true, "api", null, _this3.gettingAutoNotificationsHistoric.cancellationToken).catch(function (e) {
                _this.gettingAutoNotificationsHistoric.isPending = false;
                _this.$toasted.show("Unable to load auto notifications sents.", {
                  type: "error"
                });
                throw e;
              });
            case 7:
              response = _context2.sent;
              _this3.gettingAutoNotificationsHistoric.items = _toConsumableArray(response.data.value).sort(function (a, b) {
                return new Date(b.sendDate) - new Date(a.sendDate);
              });
              _this3.gettingAutoNotificationsHistoric.isPending = false;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getAutoNotificationsConfigs: function getAutoNotificationsConfigs() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$gettingAutoNot;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.gettingAutoNotificationsConfigs.isPending = true;
              _this4.gettingAutoNotificationsConfigs.items = [];
              (_this4$gettingAutoNot = _this4.gettingAutoNotificationsConfigs.cancellationToken) === null || _this4$gettingAutoNot === void 0 || _this4$gettingAutoNot.cancel();
              _this4.gettingAutoNotificationsConfigs.cancellationToken = axios.CancelToken.source();
              _this = _this4;
              _context3.next = 7;
              return request("/v1/order-auto-notifications/".concat(_this4.order.id_order, "/configs"), "get", null, true, "api", null, _this4.gettingAutoNotificationsConfigs.cancellationToken).catch(function (e) {
                _this.gettingAutoNotificationsConfigs.isPending = false;
                var errorData = getErrorData(e, {}, "Unable to load auto notifications configs.", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 7:
              response = _context3.sent;
              _this4.gettingAutoNotificationsConfigs.items = _toConsumableArray(response.data.value);
              _this4.gettingAutoNotificationsConfigs.isPending = false;
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    confirmDefineAutoNotificationConfig: function confirmDefineAutoNotificationConfig(notificationType, action) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.$refs.confirm.open("Confirm new setting ?", action == "forceResend" ? "Are you sure to force to send this notification tomorrow ? It should be relevent in some cases, for exemple, after the correction of email adress of customer. The notification will be sent only if the order matches all the required parameters, even if this notification has been already sent previously." : "Are you sure to prevent this notification to be sent ? The notification will NOT be sent, even if the order matches all the required parameters.", {
                color: "red",
                width: 600
              });
            case 2:
              ok = _context4.sent;
              if (ok) {
                _this5.defineAutoNotificationConfig(notificationType, action);
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    defineAutoNotificationConfig: function defineAutoNotificationConfig(notificationType, action) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this6$definingAutoNo;
        var _this, data;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this6.definingAutoNotificationConfig.isPending = true;
              (_this6$definingAutoNo = _this6.definingAutoNotificationConfig.cancellationToken) === null || _this6$definingAutoNo === void 0 || _this6$definingAutoNo.cancel();
              _this6.definingAutoNotificationConfig.cancellationToken = axios.CancelToken.source();
              _this = _this6;
              data = {
                orderId: _this6.order.id_order,
                notificationType: notificationType,
                action: action
              };
              _context6.next = 7;
              return request("/v1/order-auto-notifications/configs", "post", data, true, "api", null, _this.definingAutoNotificationConfig.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.definingAutoNotificationConfig.isPending = false;
                          _this.definingAutoNotificationConfig.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to save accountancy code.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 7:
              _context6.next = 9;
              return _this6.getAutoNotificationsConfigs();
            case 9:
              _this6.definingAutoNotificationConfig.isPending = false;
              _this6.definingAutoNotificationConfig.cancellationToken = null;
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    confirmDeleteAutoNotificationConfig: function confirmDeleteAutoNotificationConfig(id) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this7.$refs.confirm.open("Revert to default ?", "Are you sure to revert this notification to the default setting ?", {
                color: "red",
                width: 600
              });
            case 2:
              ok = _context7.sent;
              if (ok) {
                _this7.deleteAutoNotificationConfig(id);
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    deleteAutoNotificationConfig: function deleteAutoNotificationConfig(id) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this8$deletingAutoNo;
        var _this;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this8.deletingAutoNotificationConfig.isPending = true;
              (_this8$deletingAutoNo = _this8.deletingAutoNotificationConfig.cancellationToken) === null || _this8$deletingAutoNo === void 0 || _this8$deletingAutoNo.cancel();
              _this8.deletingAutoNotificationConfig.cancellationToken = axios.CancelToken.source();
              _this = _this8;
              _context9.next = 6;
              return request("/v1/order-auto-notifications/configs/".concat(id), "delete", null, true, "api", null, _this.deletingAutoNotificationConfig.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.deletingAutoNotificationConfig.isPending = false;
                          _this.deletingAutoNotificationConfig.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to revert to default setting.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 6:
              _this8.deletingAutoNotificationConfig.isPending = false;
              _this8.deletingAutoNotificationConfig.cancellationToken = null;
              _this8.gettingAutoNotificationsConfigs.items.find(function (x) {
                var _x$config;
                return ((_x$config = x.config) === null || _x$config === void 0 ? void 0 : _x$config.id) === id;
              }).config = null;
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    }
  }
};